module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recruit-dash-page"
  }, [_c('div', {
    staticClass: "dash-header"
  }, [_c('div', {
    staticClass: "dash-header-top"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "dash-meta"
  }, _vm._l((_vm.metaRows), function(item) {
    return _c('div', {
      key: item.label,
      staticClass: "dash-meta-row"
    }, [_c('span', {
      staticClass: "dash-meta-label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('span', {
      staticClass: "dash-meta-value"
    }, [_vm._v(_vm._s(item.value))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "dash-chips"
  }, _vm._l((_vm.chips), function(chip) {
    return _c('span', {
      key: chip.label,
      staticClass: "dash-chip"
    }, [_c('i', {
      staticClass: "chip-icon"
    }), _vm._v(" "), _c('span', {
      staticClass: "chip-label"
    }, [_vm._v(_vm._s(chip.label))]), _vm._v(" "), _c('span', {
      staticClass: "chip-value"
    }, [_vm._v(_vm._s(chip.value))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "filter-bar"
  }, [_c('span', {
    staticClass: "filter-label"
  }, [_vm._v("国籍")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "全部国籍"
    },
    on: {
      "on-enter": _vm.applyNationality,
      "on-blur": _vm.applyNationality
    },
    model: {
      value: (_vm.nationalityInput),
      callback: function($$v) {
        _vm.nationalityInput = $$v
      },
      expression: "nationalityInput"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "filter-label"
  }, [_vm._v("渠道")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "全部渠道",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.load
    },
    model: {
      value: (_vm.filters.regFrom),
      callback: function($$v) {
        _vm.$set(_vm.filters, "regFrom", $$v)
      },
      expression: "filters.regFrom"
    }
  }, _vm._l((_vm.channelOptions), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.param
      }
    }, [_vm._v(_vm._s(item.status === 0 ? (item.name + '（停用）') : item.name))])
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "filter-label"
  }, [_vm._v("HR")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "placeholder": "全部HR",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.load
    },
    model: {
      value: (_vm.filters.hr),
      callback: function($$v) {
        _vm.$set(_vm.filters, "hr", $$v)
      },
      expression: "filters.hr"
    }
  }, _vm._l((_vm.$constant.hrList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "filter-label"
  }, [_vm._v("时间")]), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "value": _vm.dateRange,
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "clearable": false,
      "transfer": "",
      "placeholder": "选择日期范围"
    },
    on: {
      "on-change": _vm.onDateRangeChange
    }
  }), _vm._v(" "), _c('Button', {
    on: {
      "click": function($event) {
        return _vm.setQuickRange(7)
      }
    }
  }, [_vm._v("近7天")]), _vm._v(" "), _c('Button', {
    on: {
      "click": function($event) {
        return _vm.setQuickRange(30)
      }
    }
  }, [_vm._v("近30天")]), _vm._v(" "), (_vm.loading) ? _c('Spin', {
    staticClass: "filter-spin",
    attrs: {
      "size": "small"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "kpi-grid"
  }, _vm._l((_vm.kpiCards), function(card) {
    return _c('article', {
      key: card.key,
      staticClass: "kpi-card",
      class: ['is-' + card.level, {
        'is-clickable': !!card.link
      }],
      on: {
        "click": function($event) {
          return _vm.openCard(card)
        }
      }
    }, [_c('div', {
      staticClass: "kpi-bar"
    }), _vm._v(" "), _c('div', {
      staticClass: "kpi-body"
    }, [_c('div', {
      staticClass: "kpi-title"
    }, [_c('i', {
      staticClass: "kpi-dot"
    }), _vm._v("\n            " + _vm._s(card.title) + "\n            "), (card.link) ? _c('Icon', {
      staticClass: "kpi-link",
      attrs: {
        "type": "ios-arrow-right"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "kpi-value"
    }, [_vm._v(_vm._s(card.value)), _c('span', {
      staticClass: "kpi-unit"
    }, [_vm._v("人")])]), _vm._v(" "), _c('div', {
      staticClass: "kpi-period-row"
    }, [_c('span', {
      staticClass: "kpi-period"
    }, [_vm._v(_vm._s(card.period))]), _vm._v(" "), _c('span', {
      staticClass: "kpi-compare"
    }, [_vm._v(_vm._s(card.compare))])]), _vm._v(" "), _c('p', {
      staticClass: "kpi-foot"
    }, [_vm._v(_vm._s(card.foot))])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("环节流转（按日）")]), _vm._v(" "), _c('Button', {
    staticClass: "dash-export",
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading
    },
    on: {
      "click": _vm.exportTrend
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('p', {
    staticClass: "section-desc"
  }, [_vm._v("每天进入各环节的人数，按 tch_recruit_flow 流转记录统计；当前区间 " + _vm._s(_vm.rangeText))]), _vm._v(" "), _c('div', {
    staticClass: "block-card"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.trendColumns,
      "data": _vm.trendRows,
      "loading": _vm.loading,
      "height": _vm.trendTableHeight,
      "row-class-name": _vm.trendRowClass,
      "size": "small"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dash-header-left"
  }, [_c('h1', {
    staticClass: "dash-title"
  }, [_vm._v("外教招聘数据看板")]), _vm._v(" "), _c('p', {
    staticClass: "dash-sub"
  }, [_vm._v("Teacher Recruitment Dashboard / 招聘漏斗 / 今日待办 / 环节流转")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("招聘漏斗")]), _vm._v(" "), _c('span', {
    staticClass: "section-legend"
  }, [_c('i', {
    staticClass: "legend-dot is-danger"
  }), _vm._v("红=预警\n        / "), _c('i', {
    staticClass: "legend-dot is-warning"
  }), _vm._v("黄=关注\n        / "), _c('i', {
    staticClass: "legend-dot is-healthy"
  }), _vm._v("绿=健康\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-filters"
  }, [_c('span', {
    staticClass: "filter-item"
  }, [_c('i', {
    staticClass: "legend-dot is-healthy"
  }), _vm._v("健康")]), _vm._v(" "), _c('span', {
    staticClass: "filter-item"
  }, [_c('i', {
    staticClass: "legend-dot is-warning"
  }), _vm._v("需关注")]), _vm._v(" "), _c('span', {
    staticClass: "filter-item"
  }, [_c('i', {
    staticClass: "legend-dot is-danger"
  }), _vm._v("预警")]), _vm._v(" "), _c('span', {
    staticClass: "filter-note"
  }, [_vm._v("※ 主数字为筛选后人数，右侧为不加筛选的全局人数")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03edc3be","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/recruit/TchRecruitDashboard.vue
// module id = 1613
// module chunks = 8